import { Box, Button, Menu, Portal } from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi'
import { ScriptElementType, ELEMENT_TYPE_LABELS } from '../../types/script'
import type {
  ScriptElementFormState,
  ScriptLane,
  TagPickerDto,
  QuestionPickerDto,
} from '../../types/script'
import { LaneElementCard } from './LaneElementCard'

interface MainFlowCardProps {
  element: ScriptElementFormState | null
  lanes: ScriptLane[]
  stepNumber: number | null
  onUpdate: (updates: Partial<ScriptElementFormState>) => void
  onRemove: () => void
  onCreateBranch: (branchType: string, branchKey: string, label: string) => void
  onAddElement: (type: ScriptElementType) => void
  tagOptions: TagPickerDto[]
  questionOptions: QuestionPickerDto[]
}

export function MainFlowCard({
  element,
  lanes,
  stepNumber,
  onUpdate,
  onRemove,
  onCreateBranch,
  onAddElement,
  tagOptions,
  questionOptions,
}: MainFlowCardProps) {
  // If no element, show add button
  if (!element) {
    return (
      <Box textAlign="center">
        <Menu.Root>
          <Menu.Trigger asChild><Button size="sm" variant="outline" colorPalette="brand"><FiPlus />Add Step
                        </Button></Menu.Trigger>
          <Portal><Menu.Positioner><Menu.Content>
                {Object.entries(ELEMENT_TYPE_LABELS).map(([typeStr, label]) => (
                  <Menu.Item
                    key={typeStr}
                    fontSize="sm"
                    onSelect={() => onAddElement(typeStr as ScriptElementType)}
                    value={typeStr}>
                    {label}
                  </Menu.Item>
                ))}
              </Menu.Content></Menu.Positioner></Portal>
        </Menu.Root>
      </Box>
    );
  }

  return (
    <LaneElementCard
      element={element}
      lanes={lanes}
      stepNumber={stepNumber ?? 0}
      isLast={false}
      laneColorScheme="blue"
      onUpdate={onUpdate}
      onRemove={onRemove}
      onCreateBranch={onCreateBranch}
      tagOptions={tagOptions}
      questionOptions={questionOptions}
    />
  )
}
